import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { ThemeProvider, CssBaseline } from "@mui/material";
import { Amplify } from "aws-amplify";
import { theme } from "./theme";
import { App } from "./App";
import { amplifyConfig } from "./config/amplify";
import { AuthProvider } from "./context/AuthContext";
import { NotificationProvider } from "./context/NotificationContext";
import { WorkspaceMotion } from "./WorkspaceMotion";
import { initializeAnalytics } from "@/shared/analytics/ga4";
import { AnalyticsConsent } from "@/shared/components/AnalyticsConsent";
import { recoverFromStaleBuild } from "./pwa/stale-build-recovery";
import "./styles.css";

// Configure Amplify before anything renders — auth calls in child components
// need this to be in place from the first render.
Amplify.configure(amplifyConfig);
initializeAnalytics();
recoverFromStaleBuild();

// sw.js is emitted only by production builds; it caches engine/model downloads.
if (import.meta.env.PROD && "serviceWorker" in navigator) {
  window.addEventListener("load", () => {
    navigator.serviceWorker.register("/sw.js").catch((error: unknown) => console.warn("Service worker failed", error));
    void navigator.storage?.persist?.();
  });
}

const rootElement = document.getElementById("root");
if (!rootElement) {
  throw new Error("Root element #root not found");
}

createRoot(rootElement).render(
  <StrictMode>
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <AuthProvider>
        <NotificationProvider>
          <WorkspaceMotion>
            <App />
            <AnalyticsConsent />
          </WorkspaceMotion>
        </NotificationProvider>
      </AuthProvider>
    </ThemeProvider>
  </StrictMode>,
);
